import { render, staticRenderFns } from "./RappProdReception.vue?vue&type=template&id=90922502&scoped=true&"
import script from "./RappProdReception.vue?vue&type=script&lang=js&"
export * from "./RappProdReception.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90922502",
  null
  
)

export default component.exports